import { environment } from './../../environments/environment';
import { RefreshTokenRequested, SessionExpirationRequested } from './store/session.actions';
import { tokenSesion } from './store/session.selectors';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { first, mergeMap, tap, catchError } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { Observable } from 'rxjs';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	private readonly TOKEN_HEADER_RESPONSE: string = 'token';
	private readonly FORBIDDEN: number = 403;
	
	constructor( private store: Store<AppState>, private toastService: ToastService ) {
	}

	intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		return this.store.select( tokenSesion ).pipe(
			first(),
			mergeMap( token => {
				if( this.isIntranetBackend( request.url ) ) {
					let withBearer: boolean = false;

					// Si corresponde agrego el authorization bearer
					if( token && token != '' ) {
						request = request.clone( { setHeaders: { 'Authorization': 'Bearer ' + token } } );
						withBearer = true;
					}

					// Agrego el origin alternativo, este funciona como fallback del header Origin que agrega el navegador
					request = request.clone( { setHeaders: { 'X-Client-Origin': window.location.origin } } );

					return next.handle( request ).pipe(
							tap( event => {
								if( event instanceof HttpResponse ) {
									let responseToken: string = event.headers.get( this.TOKEN_HEADER_RESPONSE );
									// Si el token de la respuesta es distinto al del store => pido un refresh token
									if( withBearer && responseToken != token )
										this.store.dispatch( new RefreshTokenRequested( { tokenSesion: responseToken } ) );
								}
								return event;
							}),
							catchError( error => {
								if( error instanceof HttpErrorResponse && error.status == this.FORBIDDEN ) {
									this.toastService.disable();
									this.store.dispatch( new SessionExpirationRequested() );
								}
								throw error;
							})
						);
				} else
					return next.handle( request );
			})
		);
	}

	private isIntranetBackend( url: string ): boolean {
		return url && ( url.startsWith( environment.backendUrl ) || url.startsWith( environment.emailAccesoUrl ) );
	}

}